// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.te-payments__placeholder{border-radius:none !important;-webkit-box-shadow:none !important;box-shadow:none !important}`, "",{"version":3,"sources":["webpack://./src/screens/common/Billing/TuitionExpress/AddPaymentMethod/style.scss"],"names":[],"mappings":"AAEE,0BACE,6BAAA,CACA,kCAAA,CAAA,0BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
